export type TClpAndCnpTestsDocumentType = SafeExtract<
  TDocumentType,
  | 'sleepPolygraphy'
  | 'sleepStudy'
  | 'spirometry'
  | 'nightOximetry'
  | 'carbonDioxideMeasurement'
  | 'diagnosticExamination'
>;

type TSecondaryDocumentType = SafeExtract<TDocumentType, 'madTherapy' | 'diagnosis'>;

export type TRelevantDocumentType = TClpAndCnpTestsDocumentType | TSecondaryDocumentType;

export const getHeaderId = (
  documents: Array<IDocumentWithTypeV2<TClpAndCnpTestsDocumentType>>,
  editing: string | undefined,
  viewing: string | undefined,
  platform: Platform | undefined,
  diagnosticExamKey?: TDiagnosticExamKeys,
): string => {
  if (!editing && !viewing) return 'clpAndCnpTests.title';
  const { _type } = documents.find(d => d._id === (editing ?? viewing)) ?? {};
  switch (platform) {
    case 'mgravis': {
      if (_type === 'diagnosticExamination' && diagnosticExamKey) {
        return `clpAndCnpTests.mgravis.${diagnosticExamCodes[diagnosticExamKey]?.code}`;
      }
      return 'clpAndCnpTests.mgravis.title';
    }
    default: {
      switch (_type) {
        case 'sleepPolygraphy':
          return 'clpAndCnpTests.sleepPolygraphy';
        case 'sleepStudy':
          return 'clpAndCnpTests.sleepStudy';
        case 'spirometry':
          return 'clpAndCnpTests.spirometry';
        case 'nightOximetry':
          return 'clpAndCnpTests.nightOximetry';
        case 'carbonDioxideMeasurement':
          return 'clpAndCnpTests.carbonDioxideMeasurement';
      }
    }
  }
  return 'clpAndCnpTests.title';
};

export const diagnosticExamCodes: Partial<Record<TDiagnosticExamKeys, ICode>> = {
  enmg: {
    codeSystem: 'THL - Toimenpideluokitus',
    code: 'XA402',
    display: 'ENMG',
  },
  repeatedNerveStimulation: {
    codeSystem: 'http://snomed.info/sct',
    code: '252748005',
    display: 'Toistostimulaatio',
  },
  singleFiberEMG: {
    codeSystem: 'http://snomed.info/sct',
    code: '252756008',
    display: 'Yksisyy-EMG',
  },
};
